
export type EnrollmentCreateSuccessResult = typeof EnrollmentCreateSuccessResult[keyof typeof EnrollmentCreateSuccessResult];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollmentCreateSuccessResult = {
  success: 'success',
} as const;
